import { render } from "./ImageSelectionView.vue?vue&type=template&id=212c4eb8"
import script from "./ImageSelectionView.vue?vue&type=script&lang=js"
export * from "./ImageSelectionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__